<template>
  <b-button-group>
    <template v-for="item in items">
      <b-button
        variant="primary"
        @click.prevent="sortBy(item)">
        <i v-if="item.icon" class="mr-1 fa fa-fw" :class="faIcon(item.icon)"></i>
        {{ item.label }}
        <template v-if="sort === item.path">
          <i
            v-if="dir && dir.toUpperCase().startsWith('ASC')"
            class="fa fa-caret-up"/>
          <i
            v-if="dir && dir.toUpperCase().startsWith('DESC')"
            class="fa fa-caret-down"/>
        </template>
      </b-button>
    </template>
  </b-button-group>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },

    sort: {
      type: String,
      default: undefined
    },

    dir: {
      type: String,
      default: 'asc'
    }
  },

  methods: {
    faIcon(icon) {
      if (icon) {
        return 'fa-' + icon;
      }

      return undefined;
    },

    sortBy(item) {
      this.$emit('sort', item);
    }
  }
};
</script>
